"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCategoryByIdEndpointRequest = void 0;
const categoryEndpointsParameter_1 = require("./categoryEndpointsParameter");
function createCategoryByIdEndpointRequest(params) {
    return {
        method: 'GET',
        endpoint: `categories/${params.categoryId}`,
        params: Object.assign({}, (0, categoryEndpointsParameter_1.parametersForCategoryEndpoint)(params)),
    };
}
exports.createCategoryByIdEndpointRequest = createCategoryByIdEndpointRequest;
